import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import { IJourneyCategory } from "config/journeys"
import Link from "gatsby-link"

interface StartJourneyProps {
  journeyCategory: IJourneyCategory
  journeyType: string
  urlPrefix: string
}

const StartJourney: React.FC<StartJourneyProps> = ({
  journeyCategory,
  journeyType,
  urlPrefix,
}) => {
  return (
    <li className={styles.item}>
      <Link
        className={styles.link}
        to={`${urlPrefix}${journeyType}`}
        id={`journeyCategory-${journeyType}`}
      >
        <div className={styles.figureWrapper}>
          <div className={styles.figure}>
            <img
              className={styles.image}
              src={journeyCategory.bstImg.small.src}
              srcSet={`${journeyCategory.bstImg.large.src} ${journeyCategory.bstImg.large.width}, ${journeyCategory.bstImg.small.src} ${journeyCategory.bstImg.large.width}`}
              alt={journeyCategory.bstImg.alt}
            />
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.text}>
            <h3 className={styles.heading}>
              <span className={styles.underline}>{journeyCategory.title}</span>
            </h3>
          </div>
          {journeyCategory.time && (
            <div className={styles.time}>
              It will take you{" "}
              <em className={styles.timeHighlight}>{journeyCategory.time}</em>
              <i
                className={cx({
                  [styles.timeIcon]: true,
                  ["bsk-icon-clock-thick"]: true,
                })}
              />
            </div>
          )}
        </div>
      </Link>
    </li>
  )
}

export default StartJourney
